"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var enabled = false;

class FDSTrace {
  log() {
    if (enabled === true) {
      console.log(...arguments);
    }
  }

  time(a) {
    if (enabled === true) {
      console.time(a);
    }
  }

  timeEnd(a) {
    if (enabled === true) {
      console.timeEnd(a);
    }
  }

}

var _default = new FDSTrace();

exports.default = _default;
module.exports = exports.default;